module.exports = __webpack_public_path__ + "static/media/Logomark_WASP_token.960a5dbf.svg";